function sticky_relocate() {
    var window_top = $(window).scrollTop();
    var marker = $('.sticy-nav');
    if (!marker.length) return; /* landing-page layouts have no marker; this threw on every scroll */
    var div_top = marker.offset().top;
    if (window_top > div_top) {
        $('header.site-header').addClass('stick_menu_main');
    } else {
      $('body').removeClass('active');
      $('header.site-header').removeClass('stick_menu_main');
      
    }
}

$(function() {
    $(window).scroll(sticky_relocate);
    sticky_relocate();
});

$(document).ready(function() {
  $('nav#AccessibleNav').click(function() {
  
      if ($('a#menu-close').hasClass('active')) {
          document.body.style.overflowY = "unset";
          document.querySelector("#menu-close").classList.toggle("active");
          document.querySelector("#AccessibleNav").classList.toggle("active");
      }
  });

  
   $('.block-selector label:first-child').click();
    $('input[type=radio][name=block-selector__radio]').change(function() {

        var getUrlParameter = function getUrlParameter(sParam) {
            var sPageURL = window.location.search.substring(1),
                sURLVariables = sPageURL.split('&'),
                sParameterName,
                i;

            for (i = 0; i < sURLVariables.length; i++) {
                sParameterName = sURLVariables[i].split('=');

                if (sParameterName[0] === sParam) {
                    return typeof sParameterName[1] === undefined ? true : decodeURIComponent(sParameterName[1]);
                }
            }
            return false;
        };
        var variant = getUrlParameter('variant');

        $('.product-offer span').hide();
      $('.product-offer span#'+variant).css('display', 'block');
    });

    $('.new-slick').slick({
        dots: true,
        infinite: true,
        speed: 300,
        slidesToShow: 3,
        slidesToScroll: 1,
        responsive: [{
            breakpoint: 1024,
            settings: {
                slidesToShow: 1,
                slidesToScroll: 1
            }
        }]
    });
   
});
if ($(window).width() < 750) {
    $('.site-footer .h4').on('click', function() {
        $(this).toggleClass('open');
         $(this).next('.site-footer__rte').slideToggle();
        $(this).next('ul.site-footer__linklist').slideToggle();
    });



    $('.site-footer__item-inner--newsletter p.h4').on('click', function() {
        $(this).toggleClass('open');
        $('.site-footer__newsletter').slideToggle();
    });

}


if(window.location.pathname === '/') {
    let collectionIdHoverEffect = document.querySelectorAll(".grid-view-item__image-container");
    let collectionImgIdHoverEffect = document.querySelectorAll(".grid-view-item__image.primary");

    for (let i = 0; i < collectionIdHoverEffect.length; i++) {
      collectionIdHoverEffect[i].addEventListener('mouseover', function() {
        collectionImgIdHoverEffect[i].classList.toggle('fade');
      });

      collectionIdHoverEffect[i].addEventListener('mouseout', function() {
        collectionImgIdHoverEffect[i].classList.toggle('fade');
      });
    }
}